"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = invariant;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function invariant(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/graphql/jsutils/invariant.js
// module id = 684
// module chunks = 168707334958949